module.exports = __webpack_public_path__ + "img/lupa.d3993eb8.svg";